import {Button, FileInput, Modal, Stack, TextInput} from "@mantine/core";
import React, {useEffect, useState} from "react";
import {showNotification} from "@mantine/notifications";
import {IconCheck} from "@tabler/icons-react";
import {CompanyAPI} from "../../api/company/CompanyAPI";

export type CreateCompanyProps = {
  isOpen: boolean;
  justClose: () => void;
  closeAndUpdate: () => void;
}

function DeviceCustomFooterDialog(attrs: CreateCompanyProps) {
  const [title, setTitle] = useState<string>('');
  const [isLoading, setLoading] = useState(false);
  const [file, setFile] = useState<File | null>(null);

  const onSubmit = () => {
    CompanyAPI.createAsync({title, file})
      .then(() => {
        showNotification({
          title: "Utworzono firmę!",
          message: "Firma została utworzona.",
          color: "green",
          icon: <IconCheck/>
        })
      })
      .then(attrs.closeAndUpdate)
      .finally(() => setLoading(false));
  }

  const reload = () => {
    if (!attrs.isOpen) {
      return;
    }

    setTitle("");
    setFile(null);
  }

  useEffect(reload, [attrs.isOpen]);

  return (
    <Modal opened={attrs.isOpen} onClose={attrs.justClose} title="Nowa firma">
      <Stack>
        <TextInput
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Nazwa firmy"
          description="Nazwa firmy"
        />

        <FileInput
          clearable
          accept=".jpeg"
          placeholder="Wybierz plik"
          value={file}
          onChange={setFile}
        />

      <Button disabled={!file} onClick={onSubmit} loading={isLoading}>Prześlij</Button>
    </Stack>
</Modal>
)
}

export default DeviceCustomFooterDialog;